
import { useEffect, useState } from "react"
import { ChartstwitsRepository } from "../../repository/ChartstwitsRepository";
import { useNavigate } from 'react-router-dom';

export function VolatileModel(){
    const apiModel = ChartstwitsRepository();
    const navigate = useNavigate();
    const [lstVolatile,setVolatile] = useState([{
        symbol: "",
        name: "",
        lastSale: 0,
        netChange: "",
        perChange: "",
        marketCap: "",
        country: "",
        ipoyear: "",
        volume: 0,
        sector: "",
        industry: "",
        open: {},
        currency: "",
        date: "",
        high: {},
        low: {},
        close: {}
    }])

    const getVolatile = async () =>{
        debugger;
        setVolatile([]);
        const responseData:any = await apiModel.getVolatileStock();
        debugger;
        if (responseData.length > 0) {
            debugger;
            setVolatile(responseData);
        }
    }

    useEffect(()=>{
        getVolatile();
    },[])

    
const back = () =>{
    debugger;
    navigate(`/dashboard`);
  }
  

    return{lstVolatile,back}
}